import { render, staticRenderFns } from "./EgrnTrustee.vue?vue&type=template&id=e1f25cae&"
import script from "./EgrnTrustee.vue?vue&type=script&lang=js&"
export * from "./EgrnTrustee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports